<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">مقدم الطلب:</label>
            <div>{{ dataRow.User.name }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">نوع الطلب:</label>
            <div>{{ (dataRow.isFree)? 'مجاني' : 'غير مجاني' }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">باسم:</label>
            <div>{{ dataRow.name }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">رقم الجوال:</label>
            <div>{{ dataRow.mobile }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <label for="" class="form-label">الاستشارة:</label>
            <div><pre>{{ dataRow.subject }}</pre></div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">قيمة الطلب:</label>
            <div>{{ dataRow.price }} {{ (dataRow.isPaid)? 'مدفوع' : 'غير مدفوع' }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">العقار:</label>
            <router-link v-if="propertyLink" :to="propertyLink">رابط العقار</router-link>
            <div v-else>لا يوجد</div>
          </div>
        </div>

        <div v-if="dataRow.couponId" class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">كوبون الخصم:</label>
            <div>
              <span v-if="dataRow.Coupon && dataRow.Coupon.code">{{ dataRow.Coupon.code }} — </span>
              {{ dataRow.couponAmount }} {{ dataRow.couponType === 'percentage' ? '٪' : 'ريال' }} خصم
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">حالة الكوبون:</label>
            <div>
              <span :class="dataRow.couponAccepted ? 'badge bg-success' : 'badge bg-warning text-dark'">
                {{ dataRow.couponAccepted ? 'مطبق' : 'لم يطبق' }}
              </span>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">قيمة الطلب بعد الخصم:</label>
            <div>{{ dataRow.priceAfterDiscount }} ريال</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">تاريخ الطلب:</label>
            <div class="date-format">{{ formatDate(dataRow.createdAt) }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">حالة الطلب:</label>
            <select v-model="status" class="form-control">
              <option v-for="(val, key) in statusChoices" :value="key" :key="key">{{ val }}</option>
            </select>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">مصدر الطلب:</label>
              <div>
                <span v-if="dataRow.requestSource === 'admin'" class="badge bg-secondary">Admin</span>
                <span v-else-if="dataRow.requestSource === 'ios'" class="badge bg-primary">IOS</span>
                <span v-else-if="dataRow.requestSource === 'android'" class="badge bg-primary">Android</span>
                <span v-else-if="dataRow.requestSource === 'website'" class="badge bg-info">Website</span>
                <span v-else-if="dataRow.requestSource" class="badge bg-light text-dark">{{ dataRow.requestSource }}</span>
                <span v-else class="text-muted">غير محدد</span>
              </div>
          </div>  
  
          <div v-if="dataRow.attachments && dataRow.attachments.length" class="row">
            <div class="col-12 mb-3">
              <label for="" class="form-label">المرفقات:</label>
              <div v-for="(f, indx) in dataRow.attachments" :key="indx">
                <a :href="`${BASE_URL}uploads/${f}`" target="_blank">{{ f }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { toast, formatDate } from '@/helpers/tools';
import { mapGetters } from 'vuex';

export default {
  name: 'LawyerReqForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    propertyRow: {
      type: Object,
      default: null,
    },
    statusObject: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      statusChoices: {},
      status: 'new',
      adminNote: '',
      propertyLink: null,
    }
  },
  computed:{
    ...mapGetters(['BASE_URL'])
  },
  methods: {
    formatDate,
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;

      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/lawyerReq/update/${this.dataRow.id}`, {
          status: this.status,
          adminNote: this.adminNote,
        });
      else
        return false;
        // api = this.$http.post('/api/admin/properties/create', formData);
      api.then(({data}) => {
        if(false){
          toast('تم إضافة الإعلان بنجاح', 'success');
          this.$router.replace('/propertyDoc').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
  },
  created(){
    if(this.dataRow){
      this.status = this.dataRow.status;
      this.adminNote = this.dataRow.adminNote;
      if(this.propertyRow){
        if(this.dataRow.propertyType == 'property')
          this.propertyLink = `/properties/update/${this.dataRow.propertyId}`;
        if(this.dataRow.propertyType == 'exchange')
          this.propertyLink = `/exchanges/update/${this.dataRow.propertyId}`;
        if(this.dataRow.propertyType == 'container')
          this.propertyLink = `/propertyContainers/update/${this.dataRow.propertyId}`;
      }
    }
    this.statusChoices = this.statusObject;
  }
}
</script>
